import { createRoute } from '@tanstack/react-router'

import { areaRoute } from '@/app/routes/area-layout'
import { lazyPage } from '@/lib/lazy-page'

export const BillingSettings = lazyPage(() => import('./features/billing-settings/billing-settings.lazy'), 'BillingSettings')

export const billingSettingsRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'billing',
  component: BillingSettings,
})
